export default {
	setBanners(state, banners) {
		state.banners = banners
	},
}
